import React from 'react';
import { Button } from '@allygpo/ally-ux';

interface ForbiddenProps {
  onLogout: () => void;
}

const Forbidden: React.FC<ForbiddenProps> = ({ onLogout }) => {
  return (
    <div
      className="flex justify-content-center align-items-center"
      style={{ height: '100vh' }}
    >
      <div className="text-center" style={{ maxWidth: '28rem', padding: '1.75rem' }}>
        <i
          className="pi pi-lock"
          style={{ fontSize: '3.5rem', color: 'var(--siq-primary)' }}
        ></i>
        <h1 className="u-mt-5 u-mb-2 text-2xl font-bold text-selected">
          Access Denied
        </h1>
        <p className="text-md" style={{ color: 'var(--siq-muted)' }}>
          You do not have permission to access this page.
        </p>
        <p className="text-xs u-mb-5" style={{ color: 'var(--siq-muted)' }}>
          If you believe this is a mistake, please contact your administrator.
        </p>
        <Button onClick={onLogout}><i className="pi pi-sign-out" aria-hidden="true" />Logout</Button>
      </div>
    </div>
  );
};

export default Forbidden;
